export default ['AND', 'OR', 'NOT'];
